import DiscreetMessage from "./DiscreetMessage";

type ContentAsyncProps = {
  loading: boolean;
  children: React.ReactNode;
};
const ContentAsync = ({ loading, children }: ContentAsyncProps) => (
  <>
    {loading && <DiscreetMessage text="Carregando ..." />}

    {!loading && children}
  </>
);

export default ContentAsync;
